import { useLazyQuery } from '@apollo/client';
import { IQueryResult, IVariables } from './interfaces';
import { suppliersQuery } from './gql';

export const useSuppliersGql = () => {
  const [runSuppliersGql, { loading, data, error }] = useLazyQuery<IQueryResult, IVariables>(suppliersQuery, {
    context: {
      headers: {
        userFunctionKey: 'a684eceee76fc522773286a895bc8436'
      }
    }
  });

  return {
    runSuppliersGql,
    loadingSuppliers: loading,
    dataSuppliers: data?.suppliers || [],
    errorSuppliers: error
  };
};
